"use client";

/* eslint-disable react/no-string-refs */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prefer-es6-class */
import Formsy, { addValidationRule } from "formsy-react";
import { PureComponent } from "react";
import FrcContext from "./hoc/frc";

addValidationRule("isNotEmpty", (values, value) => value !== undefined && value.trim() !== "");

// must be class Component to support refs commming form parent component
class MyForm extends PureComponent<any, any> {
  render() {
    const {
      children,
      className,
      elementWrapperClassName,
      labelClassName,
      layout,
      rowClassName,
      validateBeforeSubmit,
      validatePristine,
      ...formsyPassthroughProps
    } = this.props;
    const contextProps = {
      elementWrapperClassName,
      labelClassName,
      layout,
      rowClassName,
      validateBeforeSubmit,
      validatePristine,
    };
    return (
      <FrcContext.Provider value={contextProps}>
        <Formsy
          ref="formsy"
          {...this.props}
        />
      </FrcContext.Provider>
    );
  }
}

export default MyForm;
